'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLoading = setLoading;
exports.clearLoading = clearLoading;
var SET_LOADING = exports.SET_LOADING = 'SET_LOADING';
var CLEAR_LOADING = exports.CLEAR_LOADING = 'CLEAR_LOADING';

function setLoading() {
  return { type: SET_LOADING };
}

function clearLoading() {
  return { type: CLEAR_LOADING };
}


//////////////////
// WEBPACK FOOTER
// ./shared/actions/loading.js
// module id = 145
// module chunks = 0